import Chip from '@mui/material/Chip';
import Icon from 'ui/atoms/Icon';
import type { Status, ChipStatusProps } from './types';
import When from '../../support/When';

export const withChipStatus = <T extends string | number>(statusMap: Status<T>) => ({
    label,
    ...props
}: ChipStatusProps) => {
    const key = label as T;
    const { icon = '', ...overrideProps } = statusMap.get(key) ?? {};

    return (
        <When
            if={statusMap.has(key)}
            then={(
                <Chip
                    size='small'
                    {...props}
                    label={label}
                    {...overrideProps}
                    icon={(
                        <Icon name={icon} />
                    )}
                />
            )}
            else={Boolean(key) && (
                <Chip
                    size='small'
                    color='default'
                    label={key}
                />
            )}
        />
    );
};

export default withChipStatus;
